// extracted by mini-css-extract-plugin
export default {"panel":"home_panel__Qv6+S","grid-menu":"home_grid-menu__0mLDp","boxLink":"home_boxLink__PgJTo","boxOnline":"home_boxOnline__9cC3Q"};